import { CardActivityType, type CardActivityWithId } from '@/models/card-activity/card-activity.model'

export function checkIsTextAnswer(card: CardActivityWithId | undefined) {
  if (!card) return false

  return card.type === CardActivityType.RESPOND_WRITE || card.type === CardActivityType.FREE_RESPONSE
}

export function checkIsWrittenRespondCard(type: CardActivityType | undefined) {
  if (!type) return false

  return type === CardActivityType.RESPOND_WRITE || type === CardActivityType.FREE_RESPONSE
}
